import { createSlice } from "@reduxjs/toolkit";

// =============================
// LOAD FROM LOCAL STORAGE
// =============================
const storedUser = JSON.parse(localStorage.getItem("user"));
const storedToken = localStorage.getItem("token");

// =============================
// INITIAL STATE
// =============================
const initialState = storedUser
  ? {
      id: storedUser.id,
      name: storedUser.name,
      email: storedUser.email,
      role: storedUser.role,
      role_id: storedUser.role_id,
      mobile: storedUser.mobile,
      image: storedUser.image,
      branch_ids: storedUser.branch_ids || [],
      permissions: storedUser.permissions || [],
      token: storedToken || ""
    }
  : {
      id: null,
      name: "",
      email: "",
      role: "",
      role_id: null,
      mobile: "",
      image: "",
      branch_ids: [],
      permissions: [],
      token: ""
    };

// =============================
// USER SLICE
// =============================
const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    // =============================
    // SET USER
    // =============================
    setUser(state, action) {
      const {
        id,
        name,
        email,
        role,
        role_id,
        mobile,
        image,
        branch_ids,
        permissions,
        token
      } = action.payload;

      state.id = id;
      state.name = name;
      state.email = email;
      state.role = role;
      state.role_id = role_id;
      state.mobile = mobile;
      state.image = image;
      state.branch_ids = branch_ids || [];
      state.permissions = permissions || [];
      state.token = token;

      // =============================
      // SAVE TO LOCAL STORAGE
      // =============================
      localStorage.setItem(
        "user",
        JSON.stringify({
          id,
          name,
          email,
          role,
          role_id,
          mobile,
          image,
          branch_ids,
          permissions
        })
      );

      localStorage.setItem("token", token);
    },

    // =============================
    // CLEAR USER
    // =============================
    clearUser(state) {
      state.id = null;
      state.name = "";
      state.email = "";
      state.role = "";
      state.role_id = null;
      state.mobile = "";
      state.image = "";
      state.branch_ids = [];
      state.permissions = [];
      state.token = "";

      // =============================
      // CLEAR STORAGE
      // =============================
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("branches");
      localStorage.removeItem("permissions");
      localStorage.removeItem("active_branch");
    }
  }
});

export const {
  setUser,
  clearUser
} = userSlice.actions;

export default userSlice.reducer;